import { isNotEmptyAny } from '@lhb/func';

export interface StartNodeReasonData {
  isStart?: boolean;
  reason?: string;
  closeReasonName?: string;
}

export function getStartNodeReasonParts(data: StartNodeReasonData = {}) {
  const { isStart, reason, closeReasonName } = data;
  if (!isStart || !isNotEmptyAny(closeReasonName) || !isNotEmptyAny(reason)) {
    return {
      reason,
    };
  }
  return {
    closeReasonName,
    reason,
  };
}

export function formatStartNodeReason(data: StartNodeReasonData = {}) {
  const { closeReasonName, reason } = getStartNodeReasonParts(data);
  if (!isNotEmptyAny(closeReasonName)) {
    return reason;
  }
  return `${closeReasonName} 审批理由： ${reason}`;
}
